"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Toastr = require("toastr");
/**
 * Toast generates toast notifications using toastr.
 *
 * Each of the Toast functions can take a message, message and title, or HTML.
 */
var Notification = /** @class */ (function () {
    function Notification() {
    }
    Notification.info = function (message, title, options) {
        if (options === void 0) { options = {}; }
        Toastr.info(message, title, __assign({}, Notification.defaultOptions, options));
    };
    Notification.success = function (message, title, options) {
        if (options === void 0) { options = {}; }
        Toastr.success(message, title, __assign({}, Notification.successOptions, options));
    };
    Notification.warning = function (message, title, options) {
        if (options === void 0) { options = {}; }
        Toastr.warning(message, title, __assign({}, Notification.defaultOptions, options));
    };
    Notification.error = function (message, title, options) {
        if (options === void 0) { options = {}; }
        Toastr.error(message, title, __assign({}, Notification.defaultOptions, options));
    };
    Notification.defaultOptions = {
        closeButton: true,
        extendedTimeOut: 0,
        hideDuration: 500,
        hideMethod: 'slideUp',
        onShown: function () {
            // @ts-ignore
            this.classList.add('shown');
        },
        positionClass: 'toast-bottom-full-width',
        tapToDismiss: false,
        timeOut: 0,
        toastClass: 'i-notification',
    };
    Notification.successOptions = __assign({}, Notification.defaultOptions, { closeButton: false, timeOut: 4000 });
    return Notification;
}());
exports.Notification = Notification;
//# sourceMappingURL=Notification.js.map